import React, { FC } from 'react';
import { Col, Form, Input, Row, Select } from 'antd';
import { Rule } from 'antd/lib/form';
import { NamePath } from 'antd/lib/form/interface';
import { observer } from 'mobx-react-lite';
import useStore from 'src/hooks/useStore';
import { IApplicationStore } from 'src/store/root/application.store';

export interface ICountryDistrictSectionProps {
	countryName: NamePath;
	countryLabel?: string;
	countryRules?: Rule[];
	districtName: NamePath;
	districtLabel?: string;
	districtRules?: Rule[];
	disabled?: boolean;
	requireCountry?: boolean;
	requireDistrict?: boolean;
	onChange?: (value: string) => void;
}

const CountryDistrictSection: FC<ICountryDistrictSectionProps> = (props: ICountryDistrictSectionProps) => {
	const applicationStore: IApplicationStore = useStore('applicationStore');
	// const [resCountry, setResCountry] = useState(applicationStore.currentCountryCode);

	// const listResProvinces = useMemo(() => {
	// 	return applicationStore.provinces
	// 		.filter((p) => p.countryCode == resCountry)
	// 		.map((value) => {
	// 			return {
	// 				id: value.id,
	// 				label: value.name,
	// 				key: value.id,
	// 				value: value.id
	// 			};
	// 		});
	// }, [resCountry]);

	// const onResCountryChange = (key: string) => {
	// 	props.form.resetFields([props.districtName]);
	// 	setResCountry(key);
	// };
	return (
		<Row
			gutter={{
				sm: 6,
				xs: 6,
				md: 32
			}}>
			<Col xs={24} md={12} sm={24}>
				<Form.Item
					name={props.countryName}
					label={props.countryLabel ? props.countryLabel : ''}
					required={props.requireCountry}
					rules={props.countryRules || []}>
					<Select
						placeholder="Select"
						options={applicationStore.listOfCountry}
						disabled={props.disabled}
						showSearch
						onChange={props.onChange}
						filterOption={(input, option) =>
							new RegExp(`^${input.toLowerCase().trim()}`).test((option?.label ?? '').toLowerCase())
						}
					/>
				</Form.Item>
			</Col>
			<Col xs={24} md={12} sm={24}>
				<Form.Item
					name={props.districtName}
					label={props.districtLabel}
					required={props.requireDistrict}
					rules={props.districtRules || []}>
					{/* <Select placeholder="Select" options={listResProvinces} disabled={props.disabled} /> */}
					<Input disabled={props.disabled} />
				</Form.Item>
			</Col>
		</Row>
	);
};

export default observer(CountryDistrictSection);
